import GroupsIcon from '@mui/icons-material/Groups';
import SearchIcon from '@mui/icons-material/Search';

export const organizationIcon = <GroupsIcon />;
export const searchIcon = <SearchIcon />;
